import React, { useContext, useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import "admin-lte/dist/css/adminlte.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import AuthContext from "../context/AuthContext";
import { ToastProvider } from "../context/ToastContext";

const EntityBanner = ({ activeBranch }) => {
  if (!activeBranch) return null;
  const cls = activeBranch.branch_code === "TPE" ? "tpe" : "helios";
  const icon = cls === "tpe" ? "fa-graduation-cap" : "fa-school";
  const label = `${activeBranch.name}${activeBranch.branch_code ? ` (${activeBranch.branch_code})` : ""}`;
  return (
    <div className={`ims-entity-banner ${cls}`}>
      <i className={`fas ${icon}`}></i>
      <span>{label}</span>
    </div>
  );
};

const Dashboard = () => {
  const navigate = useNavigate();
  const { activeBranch } = useContext(AuthContext);

  useEffect(() => {
    import("admin-lte/dist/js/adminlte.min.js")
      .then(() => console.log("AdminLTE loaded successfully!"))
      .catch((error) => console.error("Error loading AdminLTE:", error));

    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <ToastProvider>
      <div className="wrapper">
        <Header />
        <Sidebar />
        <div className="content-wrapper">
          <EntityBanner activeBranch={activeBranch} />
          <section className="content">
            <div className="ims-content-inner">
              <Outlet key={activeBranch?.id ?? 'default'} />
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </ToastProvider>
  );
};

export default Dashboard;
